import http from "./http-common";
import { getAuthToken } from "./authService";

const BASE = "/api/v1/admin/email-media";

const authHeaders = async () => ({
  Authorization: `Bearer ${await getAuthToken()}`,
});

/** Library listing (newest first). `q` filters by original filename. */
export const listEmailMedia = async (q = "") => {
  const response = await http.get(BASE, {
    params: q ? { q } : {},
    headers: await authHeaders(),
  });
  return response.data;
};

/** Uploads one JPEG/PNG/GIF. Resolves to the stored asset incl. its permanent public URL. */
export const uploadEmailMedia = async (file) => {
  const form = new FormData();
  form.append("file", file, file.name);
  const response = await http.post(BASE, form, {
    headers: { ...(await authHeaders()), "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

/** Hides the asset from the library. The file itself is kept so sent emails keep working. */
export const archiveEmailMedia = async (id) => {
  await http.delete(`${BASE}/${id}`, { headers: await authHeaders() });
};

const EmailMediaService = { listEmailMedia, uploadEmailMedia, archiveEmailMedia };

export default EmailMediaService;
